var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSnackbarTrumpet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_118_296)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6287 4.75483L14.8752 7.31526C14.7464 7.40316 14.5939 7.45019 14.4379 7.45019H7.65387C5.93958 7.45019 4.55043 8.83689 4.55043 10.5481V11.5129C4.55043 13.2245 5.93996 14.6118 7.6529 14.6118L14.4371 14.6138C14.5931 14.6139 14.7456 14.6609 14.8743 14.7487L18.6289 17.3102C19.4004 17.8373 20.4496 17.2857 20.4496 16.3514V5.71445C20.4496 4.78045 19.4015 4.22811 18.6287 4.75483ZM17.7543 3.47678C19.5561 2.24827 22 3.53637 22 5.71445V16.3514C22 18.5294 19.555 19.8182 17.7537 18.5878L14.1972 16.1614L7.6529 16.1595C5.08303 16.1594 3 14.0785 3 11.5129V10.5481C3 7.98212 5.08331 5.90251 7.65387 5.90251H14.1983L17.7543 3.47678Z",
    fill: "#17181A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4389 5.90445C14.867 5.90445 15.2141 6.2509 15.2141 6.67829V15.3876C15.2141 15.815 14.867 16.1615 14.4389 16.1615C14.0107 16.1615 13.6636 15.815 13.6636 15.3876V6.67829C13.6636 6.2509 14.0107 5.90445 14.4389 5.90445Z",
    fill: "#17181A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1629 14.6676C10.5613 14.511 11.0114 14.7065 11.1681 15.1042L12.1269 17.5361C12.7773 19.1877 11.5746 21 9.78465 21C8.75103 21 7.82562 20.3658 7.44503 19.4062L5.9628 15.6728C5.80505 15.2754 5.99983 14.8257 6.39786 14.6682C6.79587 14.5108 7.2464 14.7052 7.40415 15.1026L8.8864 18.836C9.03522 19.2114 9.39338 19.4523 9.78465 19.4523C10.4588 19.4523 10.9428 18.7602 10.6841 18.1028L9.7254 15.671C9.56861 15.2734 9.76447 14.8241 10.1629 14.6676Z",
    fill: "#17181A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_118_296"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnackbarTrumpet);
export default __webpack_public_path__ + "static/media/snackbar-trumpet.ffa618f34f329a7dec16c7c989b9894c.svg";
export { ForwardRef as ReactComponent };